import SimpleInStream from 'components/Ad/AdSlot/SimpleInStream';
import { PageType } from 'interfaces/content/articles/Post';
import type { JSX } from 'react';
import MagazineListWrapper from './magazineListStyles';

interface MagazinesListProps {
  children: JSX.Element[] | JSX.Element;
  pageSize: number;
}

const MagazinesList = ({ children, pageSize }: MagazinesListProps) => {
  function renderListWithAds(list: JSX.Element[] | JSX.Element) {
    const newChildren: JSX.Element[] = [];

    const itemList = Array.isArray(list) ? list : [list];

    for (let i = 0; i < itemList.length; i += pageSize) {
      const newList = itemList.slice(i, i + pageSize);

      // Push each item from the sliced newList individually
      newList.forEach((item, index) => {
        newChildren.push(<div key={`item_${i + index}`}>{item}</div>);
      });

      if (i + pageSize < itemList.length) {
        newChildren.push(
          <div
            key={`adDiv_${i}`}
            className='ad-div'
          >
            <SimpleInStream
              id={i / pageSize}
              pageType={PageType.HUB}
            />
          </div>,
        );
      }
    }
    return newChildren;
  }
  return <MagazineListWrapper>{renderListWithAds(children)}</MagazineListWrapper>;
};

export default MagazinesList;
